import { render, staticRenderFns } from "./siderFilters.vue?vue&type=template&id=36089620&scoped=true&"
import script from "./siderFilters.vue?vue&type=script&lang=js&"
export * from "./siderFilters.vue?vue&type=script&lang=js&"
import style0 from "./siderFilters.vue?vue&type=style&index=0&lang=css&"
import style1 from "./siderFilters.vue?vue&type=style&index=1&id=36089620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36089620",
  null
  
)

export default component.exports